module.exports = __webpack_public_path__ + "media/honey-icons/icon-plug-na-58a33454.svg";